module.exports = __webpack_public_path__ + "static/media/unselected_tire.7697295f.svg";